module.exports = __webpack_public_path__ + "LG_G7_icon.svg?bc83406af686121d5e88225b176e2e87";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/LG_G7_icon.svg
// module id = 199
// module chunks = 0